<script>
import Layout from "/src/views/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Monitor from "@/services/Monitor";
import Swal from "sweetalert2";
import ModalAddCronExecutionTenant from "@/components/modals/monitor/cron_setup/modalAddCronExecutionTenant.vue";

export default {
  components: { Layout, PageHeader, ModalAddCronExecutionTenant },
  page: {
    title: "Cron Execution",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  created() {
    this.getCronExecutionTeam();
    this.getTenants();
    this.getCronExecution();
  },
  methods: {
    modalAddCronExecutionTenant() {
      this.$bvModal.show("add_cron_execution_tenant");
    },
    getTenants() {
      Monitor.getTenants()
          .then((response) => {
            this.tenants = response.data.tenants;
          })
          .catch((error) => {});
    },

    getCronExecutionTeam() {
      this.isBusy = true;
      Monitor.getCronExecutionTeam(1)
        .then((response) => {
          this.tableData = response.data.data;
          this.totalRows = this.tableData.length;
          // derive occupied tenants for modal filtering
          const tenants = this.tableData.map(r => r.tenant).filter(Boolean);
          this.existingTenants = Array.from(new Set(tenants));
          this.isBusy = false;
        })
        .catch((error) => {
          this.tableData = [];
          this.existingTenants = [];
        });
    },
    getCronExecution() {
      Monitor.getCronExecution(1)
        .then((response) => {
          this.cronExecution = response.data.data || [];
        })
        .catch(() => {
          this.cronExecution = [];
        });
    },
    onToggleCron(item) {
      const payload = { type: item.type, status: item.status };
      Monitor.updateCronExecution(payload)
        .then(() => {
          // success
        })
        .catch(() => {
          // revert UI on error
          item.status = item.status === 1 ? 0 : 1;
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    resetFilter(){
      this.currentTenant = ''
      this.getCronExecutionTeam()
    },


    updateCronExecutionTeam(tenant, type) {
      Swal.fire({
        title: "Delete Cron Execution?",
        text: "Remove this cron execution",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Remove!",
      }).then((result) => {
        if (result.value) {
            console.log({tenant: tenant, type: type, active: 1});
          Monitor.updateCronExecutionTeam({tenant: tenant, type: type, active: 0})
            .then((response) => {
              const res = response.data ? response.data : false;
              const error = response.data.error
                ? response.data.error
                : "Failed";
              if (res) {
                this.getCronExecutionTeam();
                Swal.fire(
                  "Remove Execution",
                  "Cron Execution Successfully Removed!",
                  "success"
                );
              } else {
                Swal.fire("Fail!", error, "warning");
              }
            })
            .catch((error) => {
              this.error = error.response.data.error
                ? error.response.data.error
                : "Delete Failed";
              this.failedmsg(this.error);
            });
        }
      });
    },
  },
  data() {
    return {
      title: "Cron Execution",
      items: [
        {
          text: "Cron Setup",
          href: "#",
        },
        {
          text: "Cron Execution",
          active: true,
        },
      ],
      isBusy: false,
      error: null,
      showModal: false,
      modalData: {},
      link_id: null,
      tenants: [],
      tableData: [],
      existingTenants: [],
      cronExecution: [],
      currentTenant: '',
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],

      sortBy: "timestamp",
      sortDesc: true,
      fields: [
        {
          key: "tenant",
          label: "Tenant",
          sortable: true,
        },
        {
          key: "type",
          label: "Type",
          sortable: true,
        },
        {
          key: "timestamp",
          label: "Timestamp",
          sortable: true,
        },
        "delete",
      ],
    };
  },
  destroyed() {},
  middleware: "authentication",
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="">
              <div class="col-md-12 d-flex flex-column">
                <h5 class="mb-3">API Cron Execution</h5>
                <div class="mb-3 d-flex align-items-center" v-for="item in cronExecution" :key="item.type">
                  <div class="me-3">{{ item.type }}</div>
                  <b-form-checkbox-group>
                    <div class="form-check form-switch form-switch-lg mb-0">
                      <input
                        v-model="item.status"
                        type="checkbox"
                        class="form-check-input"
                        :id="`switch-${item.type}`"
                        :true-value="1"
                        :false-value="0"
                        @change="onToggleCron(item)"
                      />
                    </div>
                  </b-form-checkbox-group>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card pb-4">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <a
                  href="javascript:void(0);"
                  class="btn btn-success waves-effect waves-light"
                  @click="modalAddCronExecutionTenant"
                >
                  <i class="mdi mdi-plus me-2"></i>
                  Add New Cron Execution
                </a>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <div class="table-responsive mb-0">
                <b-table
                  :busy="isBusy"
                  :items="tableData"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  show-empty
                  empty-text="No Data Found"
                  @filtered="onFiltered"
                >
                  <template v-slot:cell(server)="data">
                    <span v-if="data.item.server !== null">
                      {{ data.item.server }} |
                      {{ data.item.server_name }}
                    </span>
                  </template>

                  <template v-slot:cell(background)="data">
                    <span
                      class="badge font-size-14"
                      :class="
                        data.item.background === 1 ? 'bg-success' : 'bg-danger'
                      "
                    >
                      {{ data.item.background === 1 ? "Yes" : "No" }}
                    </span>
                  </template>
                  <template v-slot:cell(active)="data">
                    <span
                      class="badge font-size-14"
                      :class="
                        data.item.active === 1 ? 'bg-success' : 'bg-danger'
                      "
                    >
                      {{ data.item.active === 1 ? "Yes" : "No" }}
                    </span>
                  </template>

                  <template v-slot:cell(critical)="data">
                    <span
                            class="badge font-size-14"
                            :class="
                        data.item.critical === 1 ? 'bg-success' : 'bg-danger'
                      "
                    >
                      {{ data.item.critical === 1 ? "Yes" : "No" }}
                    </span>
                  </template>



                  <template v-slot:cell(delete)="data">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                          href="javascript:void(0);"
                          class="px-2 text-danger"
                          title="Remove"
                          @click="updateCronExecutionTeam(data.item.tenant, data.item.type)"
                        >
                          <i class="uil uil-trash-alt font-size-18"></i>
                        </a>
                      </li>
                    </ul>
                  </template>

                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODALS -->
    <ModalAddCronExecutionTenant 
      :existingTenants="existingTenants"
      @onRefresh="getCronExecutionTeam"
    ></ModalAddCronExecutionTenant>
    <!-- /MODALS -->
  </Layout>
</template>
